import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Pagination } from '~/components/blocks';
import { pageInfoState } from '~/state/settings_practitioners/atoms';

export const PractitionerPagination = () => {
  const [pageInfo, setPageInfo] = useAtom(pageInfoState);
  const handleChangePage = useCallback(
    (page: number) => setPageInfo((state) => ({ ...state, page })),
    [setPageInfo],
  );

  return (
    <Pagination
      currentPage={pageInfo.page}
      totalPage={pageInfo.totalPage}
      onChange={handleChangePage}
    />
  );
};
